module.exports = __webpack_public_path__ + "media/images/favicon-8b81a302270dfe20dc4e2660d486c954.ico";